import { useEffect, useState } from "react";
import { getDerivedRates, getDemandClients } from "../../../../api";
import { buildClientsById, flattenDerivedRatesResponse } from "../utils";

// Loads derived rates + buyer-client lookup once per property change.
// Each leg degrades independently — a failure in one does not blank the other.
const useDerivedRatesData = (propertyId) => {
  const [derivedRates, setDerivedRates] = useState([]);
  const [clientsById, setClientsById] = useState(() => new Map());

  useEffect(() => {
    if (!propertyId) return undefined;
    let cancelled = false;

    const load = async () => {
      try {
        const res = await getDerivedRates(propertyId);
        if (cancelled) return;
        setDerivedRates(flattenDerivedRatesResponse(res?.data));
      } catch (e) {
        globalThis.R7Insight?.error?.("Failed to load derived rates", e);
        if (!cancelled) setDerivedRates([]);
      }

      try {
        const res = await getDemandClients();
        if (cancelled) return;
        // `res.data` is the response body. The clients endpoint wraps the array
        // as `{ success, message, data: [...] }`, so the list lives at
        // `res.data.data`. Also tolerate a bare array or a paginated `content`.
        const body = res?.data;
        let clientList = [];
        if (Array.isArray(body)) {
          clientList = body;
        } else if (Array.isArray(body?.data)) {
          clientList = body.data;
        } else if (Array.isArray(body?.content)) {
          clientList = body.content;
        }
        setClientsById(buildClientsById(clientList));
      } catch (e) {
        globalThis.R7Insight?.error?.("Failed to load demand clients", e);
        if (!cancelled) setClientsById(new Map());
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [propertyId]);

  return { derivedRates, clientsById };
};

export default useDerivedRatesData;
